import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=f60d9454&scoped=true&"
import script from "./ControlPanel.vue?vue&type=script&lang=js&"
export * from "./ControlPanel.vue?vue&type=script&lang=js&"
import style0 from "./ControlPanel.vue?vue&type=style&index=0&id=f60d9454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60d9454",
  null
  
)

export default component.exports